import { SalesOrderStatus } from '../constants/sales-order-status.js';
/** From Delivery Scheduling on, the type, its assignee and the ship date can change but not clear, because Ship needs them. */
export const CARRIER_REQUIRED_SALES_ORDER_STATUS_IDS = new Set([
    SalesOrderStatus.DELIVERY_SCHEDULING,
    SalesOrderStatus.READY_TO_DELIVER,
]);
//# sourceMappingURL=carrier-required-sales-order-status-ids.js.map